<template>
    <div data-test-view="reviews-automations">
        <l-card-content>
            <l-headline :title="$t(`reviews.list.titleAutomations`)" :tabs="tabs" />

            <!-- No Data -->
            <l-no-data
                v-show="!reviewCycleList.templates.length"
                :text="$t(`reviews.list.automationsNoTemplatesH1`)"
            />
            <l-no-data
                v-show="reviewCycleList.templates.length && !reviewAutomationList.length"
                :text="$t(`reviews.list.automationsEmptyH1`)"
            />
            <!--/No Data -->

            <!-- List -->
            <div v-for="reviewAutomation in reviewAutomationList" :key="reviewAutomation._id">
                <l-reviews-automations-list-item :review-automation="reviewAutomation" />
            </div>
            <!--/List -->
        </l-card-content>

        <!-- Modal -->
        <l-modal v-show="showModal" size="l" :close-on-backdrop-click="false" @close="goBack">
            <template #header>{{ modalTitle }}</template>
            <template #body>
                <router-view></router-view>
            </template>
        </l-modal>
        <!--/Modal -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";
import LHeadline from "@/components/LHeadline";
import LModal from "@/components/LModal";
import LNoData from "@/components/LNoData";

import LReviewsAutomationsListItem from "@/components/LReviewsAutomationsListItem";

export default {
    components: {
        LCardContent,
        LHeadline,
        LModal,
        LNoData,

        LReviewsAutomationsListItem,
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        ...mapGetters({
            reviewAutomationList: "reviews/automations/list",
            reviewCycleList: "reviews/assessments/list",
        }),
        tabs() {
            return [
                {
                    show: true,
                    label: this.$t(`reviews.list.helpSetupAutomations`),
                    icon: "fal fa-external-link",
                    iconBeforeLabel: true,
                    handler() {
                        window.open(
                            `https://leapsome.zendesk.com/hc/en-us/articles/360024644673`,
                            "_blank",
                            "noopener noreferrer",
                        );
                    },
                },
                {
                    show: true,
                    tabClass: "space",
                },
                {
                    label: this.$t(`reviews.list.btnCreateAutomation`),
                    handler: () => this.createAutomation(),
                    show: Boolean(
                        this.reviewCycleList &&
                            this.reviewCycleList.templates &&
                            this.reviewCycleList.templates.length,
                    ),
                    isButton: true,
                    tabClass: "btn-primary",
                },
            ];
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                this.showModal = newRoute.meta && newRoute.meta.modal;
                this.modalTitle = this.getModalTitleFromRoute(newRoute);
            },
        },
    },
    methods: {
        getModalTitleFromRoute(route) {
            switch (route.name) {
                case "ReviewsAutomationsEdit":
                    return this.$t(`reviews.updateAutomation.title`);
                default:
                    return "";
            }
        },
        goBack() {
            this.$router.push("/reviews/automations");
        },
        createAutomation() {
            this.$router.push(`/reviews/automations/create`);
        },
    },
};
</script>
